import gql from 'graphql-tag'

export default gql`
	query LocalQuery_getClientPriceLevels($onlyActive: Boolean = true, $defaultNames: Boolean = true) {
		getClientPriceLevels(onlyActive: $onlyActive, defaultNames: $defaultNames) @client
	}
`
